import React from "react";
import {
  Box,
  Heading,
  Text,
  VStack,
  Icon,
  useColorModeValue,
  Divider,
} from "@chakra-ui/react";
import { CheckCircleIcon } from "@chakra-ui/icons";

interface ExamSubmissionConfirmationProps {
  student_given_name: string;
  exam_title: string;
  student_end_time: string; // should be formatted string
  student_email: string;
}

const ExamSubmissionConfirmation: React.FC<ExamSubmissionConfirmationProps> = ({
  student_given_name,
  exam_title,
  student_end_time,
  student_email,
}) => {
  const bg = useColorModeValue("white", "gray.800");
  const iconColor = useColorModeValue("green.500", "green.300");
  const headingColor = useColorModeValue("gray.700", "gray.100");
  const textColor = useColorModeValue("gray.600", "gray.300");

  return (
    <Box
      maxW="600px"
      mx="auto"
      mt={10}
      p={8}
      borderRadius="xl"
      boxShadow="lg"
      bg={bg}
      textAlign="center"
    >
      <VStack spacing={4}>
        <Icon as={CheckCircleIcon} w={10} h={10} color={iconColor} />
        <Heading size="lg" color={headingColor}>
          Thank you for your submission, {student_given_name}!
        </Heading>
        <Text fontSize="md" color={textColor}>
          Your attempt for <strong>{exam_title}</strong> has been successfully submitted on <strong>{student_end_time}</strong>.
        </Text>

        <Divider borderColor="gray.400" my={2} />

        <Text fontSize="md" color={textColor}>
          Once the results are published, you will be notified at your registered email address: <strong>{student_email}</strong>.
        </Text>

        <Text fontSize="sm" mt={2} color={textColor}>
          You can view your results by logging into the Eduvic LMS and navigating to the <strong>“Exam Results”</strong> section from the sidebar.
        </Text>

        <Text fontSize="xs" color="gray.500" mt={6}>
          If you have any concerns, please reach out to your tutor or Eduvic support.
        </Text>
      </VStack>
    </Box>
  );
};

export default ExamSubmissionConfirmation;
